import { useContext, useState } from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../../context/context";
import './cases.css';
import CasesCardMobile from "./casesCardMobile";


function CasesGaleryMobile() {

    const { data, loading, error, isBY, isRU, isLocal , setModal } = useContext(dataContext);
    const [showItems, setShowItems] = useState(false);

        const section = data.sectionsdata.find(s => s.nick === 'cases');
        const paragraph = section ? section.paragraphsdata.find(p => p.nick === 'cases1') : [];
        const galerydata = paragraph.galerydata;


        return (

            <motion.div className="otherCards" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true, amount: 0.25 }} transition={{ duration: 0.1 }} onAnimationComplete={() => {
                setShowItems(true);
            }}>

                {

                    galerydata.map((gal, index) => (

                        <motion.div initial={{ opacity: 0, rotateY: 360 }} animate={ showItems ? { opacity: 1, rotateY: 0 } : {}} transition={{ delay: index * 0.2, duration: 0.5 }} className="galery-main__carddesktop" key={index}>
                        <CasesCardMobile key={index} index={index} />
                        </motion.div>

                    ))

                }


                <button onClick={() => setModal(true)}>Хочу так же</button>
            </motion.div>

        )


    }

export default CasesGaleryMobile;